<div class="teacher-game-setup-overlay-footer">
  <div class="teacher-game-setup-overlay-footer__navigation">
    <brt-button [size]="'large'" [color]="'white'" [title]="'Beenden'" (click)="endGameSession()"></brt-button>
<!--    <brt-button *ngIf="gameSessionActive && !gameSessionPaused" [size]="'large'" [color]="'white'" [title]="'Pausieren'" (click)="pauseGameSession()"></brt-button>-->
    <brt-button *ngIf="gameSessionActive && gameSessionPaused" [size]="'large'" [color]="'white'" [title]="'Fortsetzen'" (click)="resumeGameSession()"></brt-button>
  </div>
</div>
